<template>
  <div>
    <transition name="el-fade-in-linear" mode="out-in">
      <div key="TEXT_SEARCH" class="verification-individual col-md-12 card" v-loading="selecting" element-loading-spinner="qc-spinner">
        <div  class="card-header">
          <h4 class="card-title">
            <span>Country</span>
          </h4>
          <div class="category">Select the country where the {{verification.type == 'employment' ? 'employer' : 'school'}} is located:</div>
        </div>
        <div class="card-content row form-horizontal">
          <div class="form-group">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-2 control-label">Country <span class="text-danger">*</span></label>
                <div class="col-sm-10">
                  <el-select
                        style="width: 100%"
                        v-model="institute"
                        :value="institute"
                        value-key="name"
                        :filterable="true"
                        :clearable="false"
                        @input="selectInstitute($event)"
                        placeholder="Select ...">
                        <!--@input="selectInstitute($event)"-->
                        <!--@input="searchInstitutes">-->
                    <el-option v-for="institute in institutes" :key="institute.id" :value="institute" :label="buildName(institute)" />
                  </el-select>
                  <span class="help-block">If the country is not listed, please contact sales@qualificationcheck.com to request coverage.</span>
                </div>
              </div>
              <div v-if="subInstitutes && subInstitutes.length > 0" class="form-group">
                <label class="col-sm-2 control-label">Examination Board / Authority <span class="text-danger">*</span></label>
                <div class="col-sm-10">
                  <el-select
                        style="width: 100%"
                        v-model="subInstitute"
                        :value="subInstitute"
                        value-key="name"
                        :filterable="true"
                        :clearable="false"
                        @input="selectInstitute($event)"
                        placeholder="Select...">
                    <el-option :key="institute.id" :value="institute" :label="'Unknown or N/A'" />
                    <el-option v-for="institute in subInstitutes" :key="institute.id" :value="institute" :label="buildName(institute)" />
                  </el-select>
                  <span class="help-block">This country verifies high school qualifications via an examination board or authority.</span>
                </div>
              </div>
<!--
              <div class="form-group">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                  <el-input />
                  <span class="help-block">If the country is not listed, please contact sales@qualificationcheck.com to request coverage.</span>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                   <p class="form-control-static"><p-switch v-model="consentTicked" type="info" on-text="Yes" off-text="No"></p-switch></p>
                  <span class="help-block">If the country is not listed, please contact sales@qualificationcheck.com to request coverage.</span>
                </div>
              </div>
--> 
            </div>
          </div>

        </div>
      
      </div>

    </transition>
  </div>
</template>
<style>
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
</style>
<script>
  import accounting from 'accounting'

  accounting.settings.currency.symbol = "£";

  export default {
    name: 'country-institute-select',
    components: {
    },
    $_veeValidate: {
      name() {
        return "institute";
      },
      value() {
        return null;
      }
    },
    props: {
      verification: {type: Object, default: null},
      application: {type: Object, default: null}
    },
    data () {
      return {
        institute: null,
        subInstitute: null,
        loading: false,
        institutes: [],
        subInstitutes:[],
        selecting: false,
      }
    },
    mounted () {
        this.selecting = true
        let instituteSummaryRequest = {
          page: 0,
          size: 1000,
          name: this.verification.type == 'employment' ? 'EMPVQCI' : 'HSVQCI',
          regionId: null
        }
        this.$api.searchInstituteSummary(instituteSummaryRequest)
          .then(response => {
            this.institutes = response.data.content
            this.selecting = false
          })
          .catch(error => {
            console.log("Failed to load high school institutes")
            this.selecting = false
          })
    },
    computed: {
    },
    methods: {
      buildName(institute) {
        var result
        if(institute.names && institute.names[0]) {
          result = institute.names[0].name
        } else {
          result = institute.name
        }
        if(!this.application || this.application.applicantPays) {
          result += ""
        }
        return result
      },
      formatMoney(value) {
        return accounting.formatMoney(value)
      },
      selectInstitute(idOrInstitute) {
        if(idOrInstitute.children > 0) {
          this.selecting = true
          let instituteSummaryRequest = {
            page: 0,
            size: 1000,
            parentId: idOrInstitute.id
          }
          this.$api.searchInstituteSummary(instituteSummaryRequest)
            .then(response => {
              this.subInstitutes = response.data.content
              this.institute.children = 0 // set this as base institute is used a default option and we don't want to get back into here.
              this.selecting = false
            })
            .catch(error => {
              console.log("Failed to load high school institutes")
              this.selecting = false
            })
        } else {
          this.selecting = true
          // if(idOrInstitute.id && !this.application) {
          //   this.$emit('select', idOrInstitute)
          // } else {
            this.$service.buildInstitute(idOrInstitute.id, null, null)
              .then(response => {
                  this.$emit('select', response)
                  this.selecting = false
              })
              .catch(error => {
                this.selecting = false
                console.log(error)
              })
        // }
        }
      }
    }
  }
</script>